import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';

export abstract class CompanyBetaProgramsTabBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getAllAvailableBetaPrograms();

  public abstract updateEnrollmentState(type: number, state: boolean);

  public abstract clearSessionsForUsersInCurrentCompany();
}
